import { Component, input } from '@angular/core'

@Component({
  selector: 'app-page-placeholder',
  template: `
    <div class="border-border bg-surface shadow-elevated max-w-xl rounded-[22px] border p-8">
      <h1 class="font-display text-ink text-2xl font-bold">{{ title() }}</h1>
      <p class="text-muted mt-3 text-sm">{{ description() }}</p>
    </div>
  `
})
export class PagePlaceholder {
  title = input.required<string>()
  description = input<string>('Esta sección está en construcción. Muy pronto encontrarás aquí todo el contenido.')
}
